import { useEffect, useState } from 'react';
import { SearchService } from '../../../services/search.service';
import { useSelector } from 'react-redux';

export const useGameSearch = (searchQuery) => {
    const [searchResultState, setSearchResult] = useState([]);
    const { config: { templateDirectoryUri } } = useSelector((state) => (state.app));
    const { gamesById } = useSelector((state) => (state.casino));

    useEffect(() => {
        // prevent race condition with setting old values to result state in case input changes
        let isSubscribed = true;

        const execSearch = async () => {
            try {
                const { gameSearchResult } = await SearchService.searchGames({
                    searchQuery,
                    allGamesById: gamesById,
                    themePublicPath: templateDirectoryUri,
                });

                if (isSubscribed) {
                    setSearchResult(gameSearchResult);
                }
            } catch (e) {
                Tools.error(e.message);
            }
        };

        if (gamesById && searchQuery.length > 0) {
            execSearch();
        }

        return () => {
            isSubscribed = false;
        };
    }, [searchQuery, gamesById]);

    return {
        searchResult: searchResultState,
    };
};
